import { AlertSuccessIcon, Button, CameraIcon, Card, Inline, Stack, styled } from 'canoe';
import React from 'react';

import { Stepper } from './components/Stepper';
import { WizardView } from './components/WizardView';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

interface Props {
  onSkip?: () => void;
  onClick: () => void;
  onGoBack: () => void;
}

export const Snapshot = ({ onClick, onGoBack, onSkip }: Props) => {
  return (
    <Card size="xl">
      <Stepper currentStep={4} />
      <Container>
        <AlertSuccessIcon size="l" color="AquaTeal" />
      </Container>
      <WizardView
        title="The Candu Chrome Extension is installed!"
        subTitle="We’ll now launch your product, please navigate to the page you’re planning to add Candu content to and take a snapshot."
      >
        <Container>
          <Inline space="normal" align="baseline" mt="s">
            <Button appearance="text" inline onClick={onGoBack}>
              Previous
            </Button>
            <Stack space="xxs" justify="center">
              <Button icon={CameraIcon} onClick={onClick}>
                Grab snapshot of your product
              </Button>
              {onSkip && (
                <Button appearance="text" variant="contrast" inline size="xsmall" onClick={onSkip}>
                  Skip (not recommended)
                </Button>
              )}
            </Stack>
          </Inline>
        </Container>
      </WizardView>
    </Card>
  );
};
